import script from "./ObjectiveWeightControl.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectiveWeightControl.vue?vue&type=script&setup=true&lang=js"

import "./ObjectiveWeightControl.vue?vue&type=style&index=0&id=57ffffe2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ffffe2"]])

export default __exports__